import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from "@mui/material";
import React, { useState } from "react";
import classes from "../../DatosCliente.module.css";
import Theme from "../../../../../constants/Theme";

function RfcRif({
  formik,
  showToast,
  isActive,
  rifSelected,
  setRifSelected,
  rifs,
}) {
  const [RFCHelperText, setRFCHelperText] = useState("Ingresa tu RFC");

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={3}
      style={{ marginBottom: 10 }}
    >
      <Box style={{ flex: "1 1 35%" }}>
        <OutlinedInput
          placeholder="RFC"
          onFocus={() =>
            setRFCHelperText("Debe coincidir con tu constancia de situación fiscal")
          }
          onChange={(e) => {
            const RFC = e.target.value.toUpperCase();
            formik.setFieldValue("RFC", RFC, true);
          }}
          value={formik.values.RFC}
          error={formik.errors.RFC && formik.touched.RFC}
          type="text"
          style={{ width: "100%" }}
          autoComplete="new-password"
        />
        <p
          style={
            formik.errors.RFC && formik.touched.RFC
              ? { color: Theme.COLORS.ERROR }
              : RFCHelperText !== "Ingresa tu RFC" ?  { fontWeight: 'bold' } : {}
          }
          className="helperText"
        >
          {formik.errors.RFC && formik.touched.RFC
            ? formik.errors.RFC
            : RFCHelperText}
        </p>
      </Box>
      <Box className={classes.secondLine} style={{ flex: "1 1 50%" }}>
        <FormControl fullWidth>
          <InputLabel>Régimen de incorporación fiscal</InputLabel>
          <Select
            label="Régimen de incorporación fiscal"
            onChange={({ target: { value } }) => {
              setRifSelected(value);
            }}
            value={rifSelected}
            defaultValue=""
            error={formik.errors.RIF && formik.touched.RIF}
          >
            {rifs.length > 0 &&
              rifs.map((rif, index) => (
                <MenuItem value={rif.codigo} key={rif.id}>
                  {`${rif.codigo} - ${rif.descripcion}`}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <p
          style={
            formik.errors.RIF && formik.touched.RIF
              ? { color: Theme.COLORS.ERROR }
              : {}
          }
          className="helperText"
        >
          {formik.errors.RIF && formik.touched.RIF
            ? formik.errors.RIF
            : "Selecciona el RIF"}
        </p>
      </Box>
    </Stack>
  );
}

export default RfcRif;
